export default __webpack_public_path__ + "static/media/NorthTees+Hartlepool2hrRapidResponseNursingTeamNT_and_ST_RRNT.a9ef72cf.jpeg";